<template>
<div>
    <!-- modal -->
    <b-modal id="getInvoiceInformationForReminderListModal" centered size="xl" no-close-on-backdrop ref="getInvoiceInformationForReminderListModal" :title="$t('invoiceReminder.invoice_information')" ok-only :ok-title="$t('others.cancel_title')" ok-variant="secondary" @close="clear()" @ok="clear()">
        <!-- Invoice Information Display -->
        <b-form v-if="invoiceInfo.debitNo" class="mb-3 pb-3 border-bottom">
            <b-row>
                <b-col class="col-lg-6">
                    <b-form-group>
                        <label>{{ $t('invoiceReminder.debit_no') }}</label>
                        <b-form-input v-model="invoiceInfo.debitNo" size="sm" disabled />
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form-group>
                        <label>{{ $t('invoiceReminder.client_accounting') }}</label>
                        <b-form-input v-model="invoiceInfo.invoiceClientAccounting" size="sm" disabled />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="col-lg-6">
                    <b-form-group>
                        <label>{{ $t('invoiceReminder.send_type') }}</label>
                        <b-form-input v-model="invoiceInfo.invoiceSendType" size="sm" disabled />
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form-group>
                        <label>{{ $t('invoiceReminder.proforma_date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="2" v-model="invoiceInfo.proformaDate" disabled></CustomDatePicker>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="col-lg-6">
                    <b-form-group>
                        <label>{{ $t('invoiceReminder.invoice_total') }}</label>
                        <b-form-input v-model="invoiceInfo.invoiceTotal" size="sm" disabled />
                    </b-form-group>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form-group>
                        <label>{{ $t('invoiceReminder.invoice_currency_code') }}</label>
                        <b-form-input v-model="invoiceInfo.invoiceCurrencyCode" size="sm" disabled />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="col-lg-12">
                    <div class="alert alert-info p-2">
                        <div class="mb-1">
                            <strong class="d-block mb-1">{{ $t('invoiceReminder.passed_days') }}:</strong>
                            <h6 class="text-primary mb-0">{{ invoiceInfo.passedDaysAfterProformaDate }} {{ $t('invoiceReminder.days') }}</h6>
                        </div>
                        <hr class="my-1">
                        <div class="mb-1">
                            <strong class="d-block mb-1">{{ $t('invoiceReminder.planned_reminder_dates') }}:</strong>
                            <b-row class="ml-2 small">
                                <b-col class="col-lg-4">
                                    <b-badge variant="primary">{{ $t('invoiceReminder.planned_first_reminder_send_date') }}</b-badge>
                                    <div class="mt-1">
                                        <CustomDatePicker :datePickerValidateOption="2" v-model="invoiceInfo.planedFirstReminderSendDate" disabled></CustomDatePicker>
                                    </div>
                                </b-col>
                                <b-col class="col-lg-4">
                                    <b-badge variant="success">{{ $t('invoiceReminder.planned_second_reminder_send_date') }}</b-badge>
                                    <div class="mt-1">
                                        <CustomDatePicker :datePickerValidateOption="2" v-model="invoiceInfo.planedSecondReminderSendDate" disabled></CustomDatePicker>
                                    </div>
                                </b-col>
                                <b-col class="col-lg-4">
                                    <b-badge variant="warning">{{ $t('invoiceReminder.planned_third_reminder_send_date') }}</b-badge>
                                    <div class="mt-1">
                                        <CustomDatePicker :datePickerValidateOption="2" v-model="invoiceInfo.planedThirdReminderSendDate" disabled></CustomDatePicker>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-form>
        <invoice-reminder-list :invoiceId="invoiceId" ref="reminderListComponent"></invoice-reminder-list>
    </b-modal>
</div>
</template>

<script>
export default {
    data() {
        return {
            invoiceId: 0,
            invoiceInfo: {}
        }
    },
    methods: {
        clear() {
            this.invoiceId = 0
            this.invoiceInfo = {}
        },
        showInfo(invoiceId) {
            this.$refs['getInvoiceInformationForReminderListModal'].show()
            this.invoiceId = invoiceId
            this.getInvoiceInfo()
        },
        getInvoiceInfo() {
            const data = {
                id: this.invoiceId
            }
            const controller = {
                name: 'InvoiceReminder',
                actionName: 'GetInvoiceInformationForReminderList'
            }
            const payload = {
                data,
                controller
            }

            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus) {
                    this.invoiceInfo = response.data
                    this.$nextTick(() => {
                        if (this.$refs.reminderListComponent) {
                            this.$refs.reminderListComponent.getInvoiceReminderListByInvoiceId()
                        }
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.alert-info {
    background-color: #e7f3ff;
    border: 1px solid #b3d9ff;
    border-radius: 0.358rem;
}
</style>
